import { useState, useEffect } from 'react'
import {
  getCheckInOutDates,
  getHotelSearchLocation,
  getQsObject,
  getRooms,
  isQSValidForPrePop
} from '../../../utils/queryHelper'

const INITIAL_VALUES = {
  location: '',
  locationObject: {},
  startLocation: '',
  startLocationObject: {},
  startDate: '',
  endDate: '',
  roomCount: 1,
  isRentalCarNeeded: false,
  isFlightNeeded: false,
  adultCount: 2,
  childrenCount: 0,
  childrenAges: [],
  tripType: 'STAY'
}

export default function useHotelsPrePop ({ search = '' }) {
  const [initialValuesWithPrePop, setInitialValuesWithPrePop] = useState(INITIAL_VALUES)

  useEffect(() => {
    let isMounted = true
    const values = {}

    function setCheckInOut ({ checkIn, checkOut } = {}) {
      if (checkIn) {
        values.startDate = checkIn
      }

      if (checkOut) {
        values.endDate = checkOut
      }
    }

    function setLocation (locationValue = {}) {
      values.location = locationValue.displayText || ''
      values.locationObject = locationValue
    }

    function setRooms (rooms) {
      values.roomCount = rooms || 1
    }

    async function setValues () {
      const qsObject = getQsObject(search)
      const shouldPrepopCity = isQSValidForPrePop(search)

      try {
        const locationValue = await getHotelSearchLocation(qsObject, shouldPrepopCity)
        setLocation(locationValue)
        setCheckInOut(getCheckInOutDates(qsObject))
        setRooms(getRooms(qsObject))

        if (isMounted) {
          setInitialValuesWithPrePop({
            ...INITIAL_VALUES,
            ...values
          })
        }
      } catch (e) {
        // todo is logging useful here?
      }
    }
    setValues()

    return () => {
      isMounted = false
    }
  }, [search])

  return initialValuesWithPrePop
}
